// Copyright (c) 2026, Dokos SAS and contributors
// License: MIT. See LICENSE

import "./index";
// @dokos
const CHECK_METHOD =
	"frappe.email.doctype.email_group.email_group_resolver.check_doctype_eligibility";
const LISTS_METHOD =
	"frappe.email.doctype.email_group.email_group_resolver.get_document_memberships";
const EMAIL_WITHDRAW_METHOD =
	"frappe.email.doctype.email_group.email_group_service.unsubscribe_email_from_commercial_groups";
const SELF_WITHDRAW_URL_METHOD =
	"frappe.email.doctype.email_group.email_group_service.get_my_email_group_unsubscribe_url";

// Sidebar card
// @dokos
function first_email_field(doctype) {
	try {
		const meta = frappe.get_meta(doctype);
		const field = (meta.fields || []).find((f) => f.options === "Email");
		return field ? field.fieldname : null;
	} catch {
		return null;
	}
}

// @dokos
function render_card(frm, data) {
	const sidebar = frm.sidebar && frm.sidebar.sidebar;
	if (!sidebar || !sidebar.length) {
		return;
	}
	sidebar.find(".email-group-lists").remove();

	const lists = data.lists || [];
	// Card header and toggle
	const card = $(`
		<div class="sidebar-section email-group-lists border-bottom">
			<div class="email-group-lists-header d-flex justify-content-between align-items-center mb-2" role="button" tabindex="0" aria-expanded="false">
				<span class="form-sidebar-items">
					<span class="form-sidebar-label">
						${frappe.utils.icon("mail", "sm")}
						<span class="ellipsis email-group-lists-label" title="${__("Show mailing lists")}">${__("Mailing lists")}</span>
					</span>
				</span>
				<span class="email-group-lists-chevron">${frappe.utils.icon("chevron-right", "sm")}</span>
				${
					frappe.model.can_write("Email Group")
						? frappe.ui.button.html({
								icon: "plus",
								variant: "ghost",
								title: `${frappe.utils.escape_html(__("You can add the Contact linked to {0} to a Mailing List", [frm.doctype]))}`,
								css_class: "email-group-add hide",
							})
						: ""
				}
			</div>
			<div class="email-group-lists-content hide">
				<div class="email-group-lists-rows"></div>
			</div>
		</div>
	`);
	// @dokos
	const toggle_lists = () => {
		const content = card.find(".email-group-lists-content");
		const expanded = content.hasClass("hide");
		content.toggleClass("hide", !expanded);
		card.find(".email-group-lists-header").attr("aria-expanded", expanded);
		card.find(".email-group-lists-label").attr(
			"title",
			expanded ? __("Hide mailing lists") : __("Show mailing lists"),
		);
		card.find(".email-group-lists-chevron").toggleClass("hide", expanded);
		card.find(".email-group-add").toggleClass("hide", !expanded);
	};
	card.find(".email-group-lists-header").on("click", (event) => {
		if (!$(event.target).closest(".email-group-add").length) {
			toggle_lists();
		}
	});
	card.find(".email-group-lists-header").on("keydown", (event) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			toggle_lists();
		}
	});
	if (frappe.model.can_write("Email Group")) {
		card.find(".email-group-add").on("click", () => open_dialog(frm));
	}

	// Membership rows
	const rows = card.find(".email-group-lists-rows");
	if (!lists.length) {
		rows.append(`<div class="text-muted small">${__("No subscriptions")}</div>`);
	}
	for (const list of lists.slice(0, 5)) {
		const row = $(
			`<div class="ml-3 py-1 d-flex align-items-center justify-content-between"></div>`,
		);
		const list_url = frappe.utils.escape_html(
			frappe.utils.get_form_link("Email Group", list.email_group),
		);
		const list_name = frappe.utils.escape_html(list.email_group);
		row.append(
			list.can_read
				? `<a class="email-group-list-link text-truncate font-weight-normal" href="${list_url}">${list_name}</a>`
				: `<span class="text-truncate">${list_name}</span>`,
		);
		const badges = $(`<div class="d-flex align-items-center flex-shrink-0"></div>`);
		if (frm.doctype === "Contact") {
			for (const entry of list.entries) {
				const active = entry.status === "Active" && !entry.unsubscribed;
				badges.append(
					` <span class="es-badge" data-theme="${active ? "green" : "amber"}">${
						active ? __("Subscribed") : __("Unsubscribed")
					}</span>`,
				);
			}
			badges.append(
				` <span class="es-badge">${frappe.utils.escape_html(list.type || "")}</span>`,
			);
			// @dokos
			if (list.type === "Marketing" && list.entries.length) {
				if (list.can_write) {
					const withdraw = $(
						frappe.ui.button.html({
							icon: "minus",
							variant: "ghost",
							size: "sm",
							title: __("Unsubscribe"),
							css_class: "email-group-withdraw",
						}),
					);
					withdraw.on("click", (event) => {
						event.preventDefault();
						event.stopPropagation();
						withdraw_from_list(frm, list);
					});
					badges.append(withdraw);
				} else if (list.self_service) {
					for (const entry of list.entries) {
						if (entry.status !== "Active" || entry.unsubscribed) continue;
						const withdraw = $(
							frappe.ui.button.html({
								icon: "minus",
								variant: "ghost",
								size: "sm",
								title: __("Unsubscribe {0}", [entry.email]),
								css_class: "email-group-withdraw",
							}),
						);
						withdraw.on("click", (event) => {
							event.preventDefault();
							event.stopPropagation();
							open_self_service_unsubscribe(entry.email, list.email_group);
						});
						badges.append(withdraw);
					}
				}
			}
		} else {
			badges.append(
				` <span class="es-badge" title="${__("Mailing list type")}" data-theme="blue">${frappe.utils.escape_html(list.type || "")}</span>`,
			);
			badges.append(
				` <span class="es-badge" title="${__("E-mail address count")}">${list.active_count}</span>`,
			);
		}
		row.append(badges);
		rows.append(row);
	}

	// Card actions
	// @dokos
	if (lists.length > 5 && frappe.model.can_read("Email Group Member")) {
		const see_all = $(
			`<a class="small">${__("See all mailing lists ({0})", [lists.length])}</a>`,
		);
		see_all.on("click", () => {
			frappe.set_route("List", "Email Group Member", {
				canonical_email: ["in", data.emails],
			});
		});
		card.find(".email-group-lists-content").append(see_all);
	}

	// @dokos
	if (
		data.account_email ||
		lists.some((list) => list.type === "Marketing" && list.self_service)
	) {
		const marketing_emails = [
			...new Set([
				...(data.account_email ? [data.account_email] : []),
				...lists
					.filter((list) => list.type === "Marketing" && list.self_service)
					.flatMap((list) => list.entries.map((entry) => entry.email)),
			]),
		];
		for (const email of marketing_emails) {
			const withdraw = $(
				frappe.ui.button.html({
					label: __("Opt out of all commercial email for {0}", [email]),
					variant: "subtil",
					css_class: "email-group-withdraw-all",
				}),
			);
			withdraw.on("click", () => open_self_service_unsubscribe(email));
			const withdraw_wrapper = $('<div class="email-group-withdraw-all-wrapper"></div>');
			withdraw_wrapper.append(withdraw);
			card.find(".email-group-lists-content").append(withdraw_wrapper);
		}
	} else if (
		frappe.model.can_write("Email Group") &&
		frappe.model.can_create("Email Group Unsubscribe")
	) {
		const withdraw = $(
			frappe.ui.button.html({
				label: __("Block all marketing lists"),
				variant: "outline",
				theme: "gray",
				css_class: "email-group-withdraw-all",
			}),
		);
		withdraw.on("click", () => unsubscribe_from_commercial_lists(frm, data.emails || []));
		const withdraw_wrapper = $('<div class="email-group-withdraw-all-wrapper"></div>');
		withdraw_wrapper.append(withdraw);
		card.find(".email-group-lists-content").append(withdraw_wrapper);
	}

	const anchor = sidebar.find(".form-shared");
	if (anchor.length) {
		anchor.after(card);
	} else {
		sidebar.append(card);
	}
}

// Mailing list actions
// @dokos
async function open_self_service_unsubscribe(email, email_group = null) {
	const tab = window.open("about:blank", "_blank");
	try {
		const url = await frappe.xcall(SELF_WITHDRAW_URL_METHOD, { email, email_group });
		if (tab) {
			tab.location = url;
		} else {
			frappe.msgprint({
				message: `<a href="${frappe.utils.escape_html(
					url,
				)}" target="_blank" rel="noopener">${__(
					"Continue to confirm your email preference",
				)}</a>`,
			});
		}
	} catch (error) {
		tab?.close();
		frappe.msgprint(error.message || __("Could not open email preferences."));
	}
}

// @dokos
function unsubscribe_from_commercial_lists(frm, emails) {
	frappe.confirm(
		__("Block all marketing mailing lists, past and future, for these email addresses?"),
		async () => {
			try {
				const result = await withdraw_emails(emails);
				frappe.msgprint({
					title: __("Commercial mailing lists"),
					message: __("{0} new opposition(s) created; {1} already existed.", [
						result.created,
						result.existing,
					]),
					indicator: "green",
				});
				setup_form_access(frm);
			} catch (error) {
				frappe.msgprint(
					error.message ||
						__("Could not remove email addresses from marketing mailing lists."),
				);
			}
		},
	);
}

// @dokos
async function withdraw_emails(emails, email_group = null) {
	const unique_emails = [...new Set(emails.map((email) => email.trim().toLowerCase()))];
	const result = { created: 0, existing: 0 };
	for (const email of unique_emails) {
		const args = { email };
		if (email_group) {
			args.email_group = email_group;
		}
		const item = await frappe.xcall(EMAIL_WITHDRAW_METHOD, args);
		result.created += item.created;
		result.existing += item.existing;
	}
	return result;
}

// @dokos
function withdraw_from_list(frm, list) {
	frappe.confirm(__("Remove all email addresses from {0}?", [list.email_group]), async () => {
		try {
			const result = await withdraw_emails(
				list.entries.map((entry) => entry.email),
				list.email_group,
			);
			frappe.msgprint({
				title: __("Commercial mailing lists"),
				message: __("{0} new opposition(s) created; {1} already existed.", [
					result.created,
					result.existing,
				]),
				indicator: "green",
			});
			setup_form_access(frm);
		} catch (error) {
			frappe.msgprint(
				error.message ||
					__(
						"Could not remove Contact email addresses from this commercial mailing list.",
					),
			);
		}
	});
}

// Form integration
// @dokos
function open_dialog(frm) {
	return Promise.resolve(
		frappe.email_group_dialog.show({
			doctype: frm.doctype,
			docname: frm.docname,
			on_added: () => setup_form_access(frm),
		}),
	).catch(() => {});
}

// @dokos
function setup_form_access(frm) {
	if (!frm || frm.doc.__islocal || !frm.sidebar) {
		return;
	}
	const { doctype, docname } = frm;
	frappe
		.xcall(CHECK_METHOD, { doctype, docname })
		.then((eligibility) => {
			if (!eligibility || !eligibility.eligible) {
				frm.sidebar.sidebar.find(".email-group-lists").remove();
				return;
			}
			frappe
				.xcall(LISTS_METHOD, {
					doctype,
					name: docname,
					generic_email_field: first_email_field(doctype),
				})
				// @dokos
				.then((data) => {
					const memberships = data || { emails: [], lists: [] };
					render_card(frm, memberships);
				})
				.catch((error) => {
					// Membership card is progressive enhancement; a failed lookup
					// must not block the form, so just remove the stale card.
					frm.sidebar.sidebar.find(".email-group-lists").remove();
				});
		})
		.catch((error) => {
			// Eligibility probe failed (e.g. offline); leave the form untouched.
		});
}

// @dokos
$(document).on("form-refresh", (event, frm) => {
	setup_form_access(frm);
});
